import { OrganizationMember } from 'types';

export const getMemberFullname = (member?: OrganizationMember) => {
    if (member == null) {
        return undefined;
    }

    const { first_name, last_name } = member;
    return `${first_name} ${last_name}`.trim();
};

export const getMemberEmail = (member?: OrganizationMember) => {
    if (member == null) {
        return undefined;
    }

    const { email } = member;
    return `${email}`.trim();
};
